export default __webpack_public_path__ + "static/clinician-c21115d848ff529d0df4b19621c13f51.webp";